<script>
export default {
  name: "sideDrawer",
  data() {
    return {
      drawer: false
    };
  }
};
</script>

<template>
  <h1>Side Drawer</h1>
  <!--  <el-drawer-->
  <!--    title="I am the title"-->
  <!--    :visible.sync="drawer"-->
  <!--    :with-header="true">-->
  <!--    <span>Hi there!</span>-->
  <!--  </el-drawer>-->
</template>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/package/sideDrawer.vue